import { useUser } from "../useUser";

export const useIsInternalAccount = (): boolean => {
  const { allstarUser } = useUser();
  const email = allstarUser?.decoded?.sub;

  return Boolean(email?.endsWith("@allstar.gg"));
};
